export function toDisplayOrder(sortOrder) {
    const n = Number(sortOrder);
    return (Number.isFinite(n) ? n : 0) + 1;
}

export function toBackendOrder(displayOrder) {
    const n = Number(displayOrder);
    return (Number.isFinite(n) ? n : 1) - 1;
}
